const addCollaboratorDetailsReducer = ( state = {
	isEmpty: false,
	isEmailValid: true,
	hasDuplicatedEmail: false,
	selectedCollaboratorIndex: -1,
}, action ) => {
	switch (action.type){
		case "IS_EMPTY":
			state = {
				...state,
				isEmpty: action.payload
			};
			break;
		case "IS_EMAIL_VALID":
			state = {
				...state,
				isEmailValid: action.payload
			};
			break;
		case "HAS_DUPLICATED_EMAIL":
			state = {
				...state,
				hasDuplicatedEmail: action.payload
			};
			break;
		case "SELECTED_COLLABORATOR_INDEX":
			state = {
				...state,
				selectedCollaboratorIndex: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default addCollaboratorDetailsReducer;